const translations = {
    en: {
        restaurants: {
            menu_card: {
                breakfast: "BREAKFAST",
                lunch: "LUNCH",
                dinner: "DINNER",
                from_to: "FROM ${from} TO ${to} "
            }
        }
    },
    de: {
        restaurants: {
            menu_card: {
                breakfast: "FRÜHSTÜCK",
                lunch: "MITTAGESSEN",
                dinner: "ABENDESSEN",
                from_to: "AB ${from} BIS ${to} "
            }
        }
    },
    es: {
        restaurants: {
            menu_card: {
                breakfast: "DESAYUNO",
                lunch: "ALMUERZO",
                dinner: "CENA",
                from_to: "DESDE ${from} HASTA ${to} "
            }
        }
    },
    fr: {
        restaurants: {
            menu_card: {
                breakfast: "PETIT-DÉJEUNER",
                lunch: "DÉJEUNER",
                dinner: "DÎNER",
                from_to: "DE ${from} À ${to} "
            }
        }
    },
    it: {
        restaurants: {
            menu_card: {
                breakfast: "COLAZIONE",
                lunch: "PRANZO",
                dinner: "CENA",
                from_to: "DALLE ${from} ALLE ${to} "
            } 
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/restaurants/MenuCard.js